import * as Yup from 'yup';
import { IDictionary } from '@constants/languages/types';

const blackoutValidationSchema = (dictionary: IDictionary) =>
  Yup.object({
    locationId: Yup.string().required('Location name is required'),
    from: Yup.date().required('Start date is required'),
    from_time: Yup.string().required('Start time is required'),
    to: Yup.date().required('End date is required'),
    to_time: Yup.string().required('End time is required'),
  });

export default blackoutValidationSchema;
